import {createSlice} from '@reduxjs/toolkit'
import {actions} from 'react-table'

interface contentState {
  notifOrder: number
  notifContract: number
  notifSalesOrder: number
  notifSIP: number
  notifNego: number
  notifFindoc: number
  notifFindocApp: number
  notifFindocRej: number
  notifFindocRev: number
  notifFindocSent: number
  notifOrderCus: number
  notifOrderSalesPI: number
  notifOrderRevisi: number
  notifOrderReject: number
  notifOrderSelesai: number
  notifContractOto: number
  notifSalesOrderOto: number
  notifSIPOto: number
  notifSIPSA: number
  notifApprovalSA: number
  notifContractSA: number
  notifSalesOrderSA: number
  notifOrderSalesAdmin: number
  notifFindocFinance: number
  notifNonSales: number
  notifAmandemenContract: number
  notifAmandemenOrder: number
  notifSIProcess: number
  notifSIAmend: number
  notifSITotal: number
  getNotif: boolean
  itemNego: any
  accesses: any
  token: any
}

const initialState: contentState = {
  notifOrder: 0,
  notifContract: 0,
  notifSalesOrder: 0,
  notifSIP: 0,
  notifNego: 0,
  notifFindoc: 0,
  notifFindocApp: 0,
  notifFindocRej: 0,
  notifFindocRev: 0,
  notifFindocSent: 0,
  notifOrderCus: 0,
  notifOrderSalesPI: 0,
  notifOrderRevisi: 0,
  notifOrderReject: 0,
  notifOrderSelesai: 0,
  notifContractOto: 0,
  notifSalesOrderOto: 0,
  notifSIPOto: 0,
  notifSIPSA: 0,
  notifApprovalSA: 0,
  notifContractSA: 0,
  notifSalesOrderSA: 0,
  notifOrderSalesAdmin: 0,
  notifFindocFinance: 0,
  notifNonSales: 0,
  notifAmandemenContract: 0,
  notifAmandemenOrder: 0,
  notifSIProcess: 0,
  notifSIAmend: 0,
  notifSITotal: 0,
  getNotif: false,
  itemNego: {},
  accesses: [],
  token: '',
}

export const contentSlice = createSlice({
  name: 'notif',
  initialState,
  reducers: {
    setNotifOrder: (state, action) => {
      state.notifOrder = action.payload
    },
    setNotifContract: (state, action) => {
      state.notifContract = action.payload
    },
    setNotifSalesOrder: (state, actions) => {
      state.notifSalesOrder = actions.payload
    },
    setNotifSIP: (state, actions) => {
      state.notifSIP = actions.payload
    },
    setNotifNego: (state, actions) => {
      state.notifNego = actions.payload
    },
    setNotifFindoc: (state, actions) => {
      state.notifFindoc = actions.payload
    },
    setNotifFindocApp: (state, actions) => {
      state.notifFindocApp = actions.payload
    },
    setNotifFindocRej: (state, actions) => {
      state.notifFindocRej = actions.payload
    },
    setNotifFindocRev: (state, actions) => {
      state.notifFindocRev = actions.payload
    },
    setNotifFindocSent: (state, actions) => {
      state.notifFindocSent = actions.payload
    },
    setNotifOrderCus: (state, actions) => {
      state.notifOrderCus = actions.payload
    },
    setNotifOrderSalesPI: (state, actions) => {
      state.notifOrderSalesPI = actions.payload
    },
    setNotifOrderRevisi: (state, actions) => {
      state.notifOrderRevisi = actions.payload
    },
    setNotifOrderReject: (state, actions) => {
      state.notifOrderReject = actions.payload
    },
    setNotifOrderSelesai: (state, actions) => {
      state.notifOrderSelesai = actions.payload
    },
    setNotifContractOto: (state, action) => {
      state.notifContractOto = action.payload
    },
    setNotifSalesOrderOto: (state, actions) => {
      state.notifSalesOrderOto = actions.payload
    },
    setNotifSIPOto: (state, actions) => {
      state.notifSIPOto = actions.payload
    },
    setNotifSIPSA: (state, actions) => {
      state.notifSIPSA = actions.payload
    },
    setNotifApprovalSA: (state, actions) => {
      state.notifApprovalSA = actions.payload
    },
    setNotifContractSA: (state, actions) => {
      state.notifContractSA = actions.payload
    },
    setNotifSalesOrderSA: (state, actions) => {
      state.notifSalesOrderSA = actions.payload
    },
    setGetNotif: (state, actions) => {
      state.getNotif = actions.payload
    },
    setNotifOrderSalesAdmin: (state, actions) => {
      state.notifOrderSalesAdmin = actions.payload
    },
    setNotifFindocFinance: (state, actions) => {
      state.notifFindocFinance = actions.payload
    },
    setNotifNonSales: (state, actions) => {
      state.notifNonSales = actions.payload
    },
    setNotifAmandemenContract: (state, actions) => {
      state.notifAmandemenContract = actions.payload
    },
    setNotifAmandemenOrder: (state, actions) => {
      state.notifAmandemenOrder = actions.payload
    },
    setNotifSIProcess: (state, actions) => {
      state.notifSIProcess = actions.payload
    },
    setNotifSIAmend: (state, actions) => {
      state.notifSIAmend = actions.payload
    },
    setNotifSITotal: (state, actions) => {
      state.notifSITotal = actions.payload
    },
    setItemNego: (state, actions) => {
      state.itemNego = actions.payload
    },
    setAccesses: (state, actions) => {
      state.accesses = actions.payload
    },
    setToken: (state, actions) => {
      state.token = actions.payload
    },
    setLogout: (state) => {
      state.notifOrder = 0
      state.notifContract = 0
      state.notifSalesOrder = 0
      state.notifSIP = 0
      state.notifNego = 0
      state.notifFindoc = 0
      state.notifFindocApp = 0
      state.notifFindocRej = 0
      state.notifFindocRev = 0
      state.notifFindocSent = 0
      state.notifOrderCus = 0
      state.notifOrderSalesPI = 0
      state.notifOrderRevisi = 0
      state.notifOrderReject = 0
      state.notifOrderSelesai = 0
      state.notifContractOto = 0
      state.notifSalesOrderOto = 0
      state.notifSIPOto = 0
      state.notifSIPSA = 0
      state.notifApprovalSA = 0
      state.notifContractSA = 0
      state.notifSalesOrderSA = 0
      state.notifOrderSalesAdmin = 0
      state.notifFindocFinance = 0
      state.notifNonSales = 0
      state.notifAmandemenContract = 0
      state.notifAmandemenOrder = 0
      state.notifSIProcess = 0
      state.notifSIAmend = 0
      state.notifSITotal = 0
      state.itemNego = {}
      state.accesses = []
    },
  },
})

export const {
  setNotifOrder,
  setNotifContract,
  setNotifSalesOrder,
  setNotifSIP,
  setNotifNego,
  setNotifFindoc,
  setNotifFindocApp,
  setNotifFindocRej,
  setNotifFindocRev,
  setNotifFindocSent,
  setNotifOrderCus,
  setNotifOrderSalesPI,
  setNotifOrderRevisi,
  setNotifOrderReject,
  setNotifOrderSelesai,
  setNotifContractOto,
  setNotifSalesOrderOto,
  setNotifSIPOto,
  setNotifSIPSA,
  setNotifApprovalSA,
  setNotifContractSA,
  setNotifSalesOrderSA,
  setGetNotif,
  setNotifOrderSalesAdmin,
  setNotifFindocFinance,
  setNotifNonSales,
  setNotifAmandemenContract,
  setNotifAmandemenOrder,
  setNotifSIProcess,
  setNotifSIAmend,
  setNotifSITotal,
  setItemNego,
  setAccesses,
  setLogout,
  setToken,
} = contentSlice.actions

export default contentSlice.reducer
